import get from 'lodash.get';
import { startCase } from 'lodash';
import { states } from '../../translators';
import formatWithMask from '../../utils/FormatWithMask';
import { format, isValid, parse } from 'date-fns';
import { USD_CURRENCY } from '../../utils';
export const IndicatorOptions = [{
  label: 'Yes',
  value: 'true',
  id: 'Yes'
}, {
  label: 'No',
  value: 'false',
  id: 'No'
}];
export const masks = {
  phone_number: {
    mask: ['(', /\d/, /\d/, /\d/, ') ', /\d/, /\d/, /\d/, ' - ', /\d/, /\d/, /\d/, /\d/]
  },
  ssn: {
    mask: [[/\d/], [/\d/], [/\d/], '-', [/\d/], [/\d/], '-', /\d/, /\d/, /\d/, /\d/],
    obfuscationCharacter: '*'
  },
  zip_code: {
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  },
  currency: {
    mask: USD_CURRENCY
  }
};
export const safeDateParser = date => {
  if (!date || !isValid(new Date(date))) return '';
  try {
    const parsed = parse(date, 'yyyy-MM-dd', new Date());
    return format(parsed, 'MM/dd/yyyy');
  } catch (e) {
    return date;
  }
};
export const currencyFormatter = input => {
  if ((input || input === 0) && !isNaN(Number(input))) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(Math.abs(Number(input)));
  }
  return '';
};
class Translation {
  constructor() {
    let translations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.locale = translations;
  }
  setTranslations() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.locale = options;
  }
  getTranslations() {
    return this.locale;
  }
  getOptions = key => get(this.getTranslations(), [key], undefined);
  translate = (key, tOptions) => {
    const options = this.getOptions(key);
    return options && tOptions && tOptions.returnObjects ? options : (options === null || options === void 0 ? void 0 : options.label) || startCase(key);
  };
  format = (key, text) => {
    const {
      type
    } = this.getOptions(key) || {
      type: undefined
    };
    if (!type) return text;
    switch (type) {
      case 'phone_number':
      case 'zip_code':
        const {
          mask
        } = masks[type];
        return formatWithMask({
          mask,
          text: `${text}`
        }).masked;
      case 'date':
        return safeDateParser(text);
      case 'currency':
        return currencyFormatter(text);
      case 'ssn':
        const {
          mask: ssnMask,
          obfuscationCharacter
        } = masks[type];
        return formatWithMask({
          mask: ssnMask,
          text: `${text}`,
          obfuscationCharacter
        }).obfuscated;
      case 'state_code':
        return get(states, [text], '');
      case 'indicator':
        return `${text}` === 'true' ? 'Yes' : 'No';
      default:
        return text;
    }
  };
}
const iTranslation = new Translation({});
export default iTranslation;
//# sourceMappingURL=Translation.js.map